module.exports = __webpack_public_path__ + "img/brain-arrow-curved-right.74e027d8.svg";